import { getCurrentAccountId, useAccountsStore } from "@helium10/re-core";

export const useRefundGeniePermission = () => {
  // 子账号没有RG权限跳转403页面 - 基础数据
  const accountId = getCurrentAccountId();
  const accounts = useAccountsStore((s) => s.accounts);
  const account = accounts[Number(accountId)];
  // 1代表主账号永远有RG的权限,2代表子账号此时只有权限列表permissions中有RG的权限才能让跳转RG页面,否则去403页面
  // 假设所有的子账号都有RG权限,只有当前账号是子账号且没有refundgenie的时候代表没有RG权限,需要跳转403页面
  const deniedRGPermission = account?.role === 2 && !account?.permissions?.includes("refundgenie");
  return deniedRGPermission; // true代表没有权限,这样做的目的是为了等待接口回来数据
};
